import { useParams } from 'react-router-dom';

import { SpaceDiscriminator, useGetCommercialSpacesByIdQuery } from '@client/api';

import { SpaceAreaHistoryCard } from '../components/space-area-history/space-area-history-card.component';
import { SpaceInformationCard } from '../components/space-information/space-information-card.component';

export const CommercialSpaceView = () => {
  const { spaceId, discriminator } = useParams<{ spaceId: string; discriminator: SpaceDiscriminator }>();

  const { data: space, isFetching } = useGetCommercialSpacesByIdQuery(
    {
      id: spaceId ?? '',
    },
    { skip: !spaceId },
  );

  return (
    <div className="relative md:flex">
      <div className="w-full mb-2 space-y-2">
        <SpaceInformationCard space={space} isFetching={isFetching} discriminator={discriminator} />

        <SpaceAreaHistoryCard spaceId={spaceId} />
      </div>
    </div>
  );
};
